import { create } from "zustand"
import { SituationFeatureCollection } from "../../services/OgcService/models/SituationFeatureCollection";

export interface ITrafficMessageRestrictionActions {
    setTrafficMessages: (feature: SituationFeatureCollection | null ) => void;
    setIsLoading: (isLoading : boolean) => void;
}

export interface ITrafficMessageRestrictionState{
    trafficMessages: SituationFeatureCollection | null,
    isLoading : boolean,
    actions: ITrafficMessageRestrictionActions;
}

const useTrafficMessageStore = create<ITrafficMessageRestrictionState>( (set) => ({
    trafficMessages: null,
    isLoading: false,
    actions: {
        setTrafficMessages: (trafficMessages: SituationFeatureCollection | null) => {
            set({trafficMessages: trafficMessages});
        },
        setIsLoading: (isLoading: boolean) => {
            set({isLoading : isLoading})
        }
    }
}));

export const useTrafficMessages = () => useTrafficMessageStore((state) => state.trafficMessages);
export const useTrafficMessageIsLoading = () => useTrafficMessageStore((state) => state.isLoading);
export const useTrafficMessageActions = () => useTrafficMessageStore((state) => state.actions);